import jss from 'jss'
import preset from 'jss-preset-default'

jss.setup(preset())

export default jss



// WEBPACK FOOTER //
// ./src/lib/services/Jss.js